import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditorComponent } from 'ngx-monaco-editor-v2';
import { TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  imports: [TranslatePipe, EditorComponent, ReactiveFormsModule, FormsModule],
})
export class CodeComponent implements OnInit, AfterViewInit {
  modalRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(
    DynamicDialogConfig<{
      title?: string;
      description?: string;
      code?: string | object;
      codeLanguage?: string;
      documentationLink?: string;
      buttonText?: string;
    }>,
  );

  title = 'dataconnection.code';

  description?: string;

  code = '';

  codeLanguage = 'javascript';

  documentationLink?: string;

  buttonText = 'close';

  @ViewChild('lineWrap') lineWrap!: ElementRef;

  @ViewChild('editor') editor!: EditorComponent;

  lineWrapBoolean = true;

  LINE_WRAP_KEY = 'code_line_wrap';

  editorOptions = {
    automaticLayout: true,
    theme: 'vs-dark',
    language: 'javascript',
    fontSize: '14',
    wordWrap: 'on',
    scrollbar: {
      alwaysConsumeMouseWheel: false,
    },
  };

  constructor() {
    Object.assign(this, this.dialogConfig.data);
  }

  ngOnInit(): void {
    if (typeof this.code === 'object') {
      this.code = JSON.stringify(this.code, null, 2);
    }
    if (!localStorage.getItem(this.LINE_WRAP_KEY)) {
      localStorage.setItem(this.LINE_WRAP_KEY, this.lineWrapBoolean.toString());
    }
  }

  ngAfterViewInit(): void {
    this.editorOptions.language = this.codeLanguage;
    this.editor.options = this.editorOptions;

    this.lineWrapBoolean = localStorage.getItem(this.LINE_WRAP_KEY) === 'true';
    this.lineWrap.nativeElement.checked = this.lineWrapBoolean;
    this.lineWrap.nativeElement.addEventListener('change', () => {
      this.lineWrapBoolean = this.lineWrap.nativeElement.checked;
      localStorage.setItem(this.LINE_WRAP_KEY, this.lineWrapBoolean.toString());
      this.editorOptions.wordWrap = this.lineWrapBoolean ? 'on' : 'off';
      this.editor.options = this.editorOptions;
    });
  }

  close(): void {
    this.modalRef.close(this.code);
  }
}
